import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'tooltip',
  imports: [CommonModule],
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {
  @Input() tooltip: string = '';
  @Input() contentRef: TemplateRef<unknown> | undefined;

  left: number = 0;
  bottom: number = 0;
  right: number = 0;
  top: number = 0;
  width?: number = 134;

  tooltipStyles: Partial<CSSStyleDeclaration> = {};


  ngOnInit(): void {
    this.updateTooltipPosition()
  }

  updateTooltipPosition(): void {
    this.tooltipStyles.left = `${this.left}px`;
    if (this.top !== 0) {
      this.tooltipStyles.top = `${this.top}px`;
    } else if (this.bottom !== 0) {
      this.tooltipStyles.bottom = `${this.bottom}px`;
    }
    this.tooltipStyles.maxWidth = `${this.width}px`
  }

}
